module.exports = "/assets/1a5cb6eafdda6167a66a1a52699af97f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/WP.png
// module id = 1968
// module chunks = 0